import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { AuthService } from './auth.service';
import { MenuVisibilityService } from '../menu-visibility.service';

@Injectable({
  providedIn: 'root'
})
export class LandingGuard implements CanActivate {

  constructor(
    private authService: AuthService,
    private router: Router,
    private menuVisibility: MenuVisibilityService
  ) { }

  /**
   * Route root visitors by auth state:
   * - authenticated -> dashboard
   * - unauthenticated -> marketing home
   */
  async canActivate(): Promise<boolean | UrlTree> {
    try {
      const isAuthenticated = await this.authService.isAuthenticated();
      if (isAuthenticated) {
        const lastAppRoute = this.menuVisibility.getLastAppRoute();
        if (lastAppRoute) {
          return this.router.parseUrl(lastAppRoute);
        }

        return this.router.createUrlTree(['/dashboard']);
      }

      return true;
    } catch (error) {
      console.error('Error in LandingGuard:', error);
      return true;
    }
  }
}
